module.exports = __webpack_public_path__ + "static/media/download.f824b28a.jpg";